import React, {useState ,useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import Core from "../components/core-view";
import { clientAdminRequestGet } from 'modules/portal-module';

import {
  uiAlertAuthenticationWarningVisible,
  uiAlertAuthenticationExpiredVisible,
  uiToastrMessage,
  uiConfirmDialog,
} from "modules/ui-module";

export const getValuesFromStore = (state) => ({
  alertAuthWarningIsVisible: uiAlertAuthenticationWarningVisible(state),
  alertAuthExpiredIsVisible: uiAlertAuthenticationExpiredVisible(state),
  toastrMessage: uiToastrMessage(state),
  confirmDialog: uiConfirmDialog(state),
});

export const CoreContainer = () => {
  const {
    alertAuthWarningIsVisible,
    alertAuthExpiredIsVisible,
    toastrMessage,
    confirmDialog,
  } = useSelector(getValuesFromStore);
  const [clientIsAdmin ,setClientIsAdmin] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
      dispatch(clientAdminRequestGet()).then((response) => {
        if (response && response.payload && response.payload.admin) {
          setClientIsAdmin(true);
        } else {
          setClientIsAdmin(false);
        }
      });
  },[dispatch]);

  return (
    <Core
      alertAuthWarningIsVisible={alertAuthWarningIsVisible}
      alertAuthExpiredIsVisible={alertAuthExpiredIsVisible}
      toastrMessage={toastrMessage}
      confirmDialog={confirmDialog}
      clientIsAdmin={clientIsAdmin}
    />
  );
};

CoreContainer.propTypes = {
  toastrMessage: PropTypes.shape({
    type: PropTypes.string,
    messageId: PropTypes.string,
    params: PropTypes.object,
  }),
  confirmDialog: PropTypes.shape({
    textResourceId: PropTypes.string,
    yesCallbackFn: PropTypes.func,
    noCallbackFn: PropTypes.func,
  }),
};

export default CoreContainer;
